import { allNews, nedvexNews, favoritesNews } from 'actions/news';
// import { createPaginationReducer } from 'reducers'
import { createReducer } from 'redux-act';

const createPaginationReducer = (action) => {
  const defaultsState = {
    loading: false,
    request: null,
    data: null,
    error: null,
    offset: 0,
    finished: false
  };

  return createReducer({
    [action.request]: (state, payload) => ({
      ...state,
      request: payload,
      loading: true,
      error: null,
      offset: state.offset + payload.limit
    }),
    [action.ok]: (state, payload) => ({
      ...state,
      loading: false,
      finished: payload.response.length < payload.request[0].limit,
      data: payload.request[0].offset === 0 ?
        payload.response :
        [...state.data, ...payload.response]
    }),
    [action.error]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
      offset: state.offset - payload.request[0].limit
    })
  }, defaultsState);
};

export const allNewsReducer = createPaginationReducer(allNews);
export const nedvexNewsReducer = createPaginationReducer(nedvexNews);
export const favoritesNewsReducer = createPaginationReducer(favoritesNews);



// WEBPACK FOOTER //
// ./src/reducers/news.js